import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {},
  sizes: {
    default: {
      width: '6',
      height: '6',
    },
    small: {
      width: '5',
      height: '5',
    },
    'extra-small': {
      width: '4',
      height: '4',
    },
  },
  defaultProps: {
    size: 'default',
  },
};
